import FastMarquee from "react-fast-marquee";

const ITEMS = ["NO GIMMICKS", "NO SHORTCUTS", "NO DISPOSABLE PRODUCTS", "BUILT FOR WORK"];

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-zinc-800 py-8 md:py-10">
      <FastMarquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16 md:mx-16">
            <span className="text-outline whitespace-nowrap font-display text-6xl font-bold uppercase leading-none tracking-tight md:text-8xl">
              {item}
            </span>
            <span className="h-3 w-3 rotate-45 border border-zinc-600" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
